<bs-standard-modal (modalComplete)="onComplete($event)" [hideCancel]="true">
  <ng-container title>Version information</ng-container>

  <ng-container confirmButton>Close</ng-container>

  <a href="https://www.kontron.com/"><img id="logo" src="assets/img/logo.svg" height="50" /></a>
  <table>
    <th>Service</th>
    <th>Version</th>
    @for (serviceVersion of versions; track serviceVersion) {
      <tr>
        <td>{{ serviceVersion[0] }}</td>
        <td>{{ serviceVersion[1] }}</td>
      </tr>
    }
  </table>
</bs-standard-modal>
